import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";

const ProtectedRoute = ({ children }) => {
  const { user, loaderUser, setLoaderUser } = useContext(AuthContext);
  let location = useLocation();
  if (isEmpty(user) && !loaderUser) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
};

export default ProtectedRoute;
